import {ExternalBackend} from "./ExternalBackend";

export class JimizzWorkflow extends ExternalBackend {

  constructor(params) {
    super("jimizz", params);
  }
}